import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { AppLayout } from "@/components/layouts/AppLayout";
import { trpc } from "@/lib/trpc";
import { useCommunity } from "@/contexts/CommunityContext";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ShieldX } from "lucide-react";

export const Route = createFileRoute("/guard")({
  component: Guard,
});

function Guard() {
  const { data: user, isLoading: userLoading } = trpc.user.me.useQuery();
  const { selectedCommunityId } = useCommunity();
  const { data: communities, isLoading: communitiesLoading } =
    trpc.amenity.getUserCommunities.useQuery();

  const isLoading = userLoading || communitiesLoading;

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  const effectiveCommunityId = selectedCommunityId ?? communities?.[0]?.id;

  // Check if user has SECURITY role in selected (or fallback) community
  const currentCommunity = communities?.find(
    (c) => c.id === effectiveCommunityId,
  );
  const isSecurityGuard = currentCommunity?.role === "SECURITY";

  if (!isSecurityGuard) {
    return (
      <AppLayout>
        <div className="container mx-auto max-w-4xl px-6 py-10">
          <Alert variant="destructive">
            <ShieldX className="h-4 w-4" />
            <AlertTitle>Acceso denegado</AlertTitle>
            <AlertDescription>
              Esta sección está disponible solo para personal de seguridad. Si
              creés que deberías tener acceso, contactá a la administración del
              barrio.
            </AlertDescription>
          </Alert>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
